import React, { useEffect, useState } from "react";

import { Box, Typography } from "@mui/material";

import { loaderStyles } from "../styles/themeStyles";

interface LoaderProps {
  text?: string;
  size?: "small" | "medium" | "large";
}

const Loader = ({ text = "Loading", size = "medium" }: LoaderProps) => {
  const [loadingDots, setLoadingDots] = useState(".");

  // Loading dots animation
  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingDots((prev) => (prev.length >= 3 ? "." : prev + "."));
    }, 400);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={loaderStyles.container}>
      {/* Progress bar container */}
      <Box sx={loaderStyles.progressBar(size)}>
        {/* Animated progress bar */}
        <Box sx={loaderStyles.progressBarInner} />
      </Box>

      {text && (
        <Typography
          variant={loaderStyles.getVariant(size)}
          sx={loaderStyles.text(size)}
        >
          {text}
          {loadingDots}
        </Typography>
      )}
    </Box>
  );
};

export default Loader;